﻿import {useReactiveGetRequest} from "../request/useReactiveGetRequest";
import {locationRequests} from "../../requests/api-endpoints";
import {ILocationName} from "../components/location/useAllLocationNames";

const useGetLocationNames = () => {
  const {
    data: locationNames,
    isLoading,
    error
  } = useReactiveGetRequest<ILocationName[]>({ requestUrl: locationRequests.locationNames });

  return {
    locationNames,
    isLoading,
    error,
  }
}

export { useGetLocationNames };
